import { useTranslation } from 'react-i18next';

import { useDependencies } from '../../dependencies';
import { Button } from './Button';

const CARILOOP_LOGO_URL = 'https://assets.urbansitter.com/static/img/logos/cariloop.svg';

const CariloopButton = (): JSX.Element => {
  const { t } = useTranslation();
  const { services: { config } } = useDependencies();

  const handleCariloopClick = (): void => {
    window.location.href = config.CARILOOP_URL;
  };

  return (
    <Button
      className='border-2 border-cariloop hover:border-cariloop-400 w-[160px] rounded-full py-2 mb-0.5'
      name={t('components.buttons.cariloop')}
      onClick={handleCariloopClick}>
      <img
        src={CARILOOP_LOGO_URL}
        alt={t('components.buttons.cariloop')}
        className='h-6 mx-auto group-hover:brightness-0 group-hover:invert'
      />
    </Button>
  );
};

export { CariloopButton };
